<div
  class="sports-live-navbar-container"
  [ngClass]="{
    'background-color-regular': light,
    'background-color-dark': !light
  }"
>
  <div class="sports-live-navbar--content">
    <button
      class="sports-live-navbar--back-button codere-icon icon-arrow-left"
      [ngClass]="{
        'background-color-regular': light,
        'background-color-dark': !light,
        'color-muted': light,
        'color-light': !light
      }"
      tappable
      (click)="close?.emit()"
      *ngIf="hasBackButton"
    ></button>
    <p class="sports-live-navbar--breadcrumbs">
      <span
        *ngFor="let breadcrumb of breadcrumbs; let last = last"
        class="sports-live-navbar--link"
        [ngClass]="{
          'color-muted': light,
          'color-light': !light
        }"
      >
        {{ last ? breadcrumb : (breadcrumb + ' / ' | sportsTitleCase) }}
      </span>
    </p>
  </div>
  <div class="sports-live-navbar--actions">
      <button
        tappable
        (click)="setFilterType.emit(LIVE_MARKET_FILTER_TYPES.SPORTRADAR)"
        [ngClass]="{ 'is-active': isSportradarActive }"
        [hidden]="hideFilterSportradar"
        class="sports-live-navbar--scoreboard-button background-color-dark color-light codere-icon icon-visualisation"
      ></button>
      <button
        tappable
        (click)="setFilterType.emit(LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING)"
        [ngClass]="{ 'is-active': isVideoStreamingActive }"
        [hidden]="hideFilterVideoStreaming"
        class="sports-live-navbar--streaming-button background-color-dark color-light codere-icon icon-videolive"
      ></button>
      <button
        tappable
        (click)="setFilterType.emit(LIVE_MARKET_FILTER_TYPES.SCOREBOARD)"
        [ngClass]="{ 'is-active': isScoreboardActive }"
        [hidden]="hideFilterScoreboard"
        class="sports-live-navbar--scoreboard-button background-color-dark color-light codere-icon icon-en-directo-scoreboard"
      ></button>
  </div>
</div>
